import { createLifecycleFor } from 'ext/lib/collections';

export const { send, resolve, reject } = createLifecycleFor(
  'experiences-summary'
);
